module.exports = __webpack_public_path__ + "img/vim.b2b12db5.png";